/* HAYM storefront collection card photo gallery. */
document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-gallery-dir]');
  if (!button) return;
  event.preventDefault();
  event.stopPropagation();
  const gallery = button.closest('[data-haym-gallery]');
  const card = button.closest('.card__media, .haym-products__photo');
  if (!gallery || !card) return;
  const sources = Array.from(gallery.querySelectorAll('.haym-card-gallery__source'));
  const image = card.querySelector('.media > img, .haym-products__image');
  if (!image || sources.length < 2) return;
  const current = Number(gallery.dataset.index) || 0;
  const delta = Number(button.dataset.galleryDir) || 1;
  const next = (current + delta + sources.length) % sources.length;
  gallery.dataset.index = String(next);
  image.removeAttribute('srcset');
  image.removeAttribute('sizes');
  image.src = sources[next].dataset.src;
  image.alt = sources[next].dataset.alt || image.alt;
  const counter = gallery.querySelector('.haym-card-gallery__count');
  if (counter) counter.textContent = (next + 1) + ' / ' + sources.length;
});
